module.exports = __webpack_public_path__ + "static/media/simplonoi-headline-webfont.b30716f9.svg";